import { render, staticRenderFns } from "./LevelSelection.vue?vue&type=template&id=08d86517&"
import script from "./LevelSelection.vue?vue&type=script&lang=js&"
export * from "./LevelSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports